import classes from './NotificationDiv.module.css'
import { useNavigate } from 'react-router-dom'
import Cookies from 'js-cookie'
import { BASE_URL } from '../../../Apis/BaseUrl'
import axios from 'axios'
import {
  ShoppingCartOutlined,
  DollarOutlined,
  ExclamationCircleOutlined,
  FileTextOutlined,
  TruckOutlined,
  UserOutlined,
  HeartOutlined,
  StarOutlined,
  GiftOutlined,
  BellOutlined
} from '@ant-design/icons'
import { Badge, Typography } from 'antd'
import moment from 'moment';

const { Text, Paragraph } = Typography;

const NotificationDiv = ({
  subject,
  description,
  seen,
  redirect,
  refreshFunc,
  _id,
  createdAt,
  parentFunc,
  priority,
  category,
  index,
  data
}) => {

  const links = {
    // Order related
    "order": 'sales/allorder',
    "payment": 'sales/payment',
    "refund request": 'refund',
    "withdraw request": 'sales/withdraw',
    "draft": 'sales/draft', // Fixed: should be /sales/draft, not /draft

    // Product related
    "product": 'product/allproduct',
    "review": 'product/productreview', // Fixed: should be /product/productreview, not /product/reviews

    // Shipping related (Admin doesn't have shipping route, redirect to orders)
    "shipping": 'sales/allorder', // Fixed: Admin doesn't have /shipping route, redirect to orders
    "delivery": 'sales/allorder', // Fixed: Admin doesn't have /delivery route, redirect to orders
    "tracking": 'sales/allorder', // Fixed: Admin doesn't have /tracking route, redirect to orders

    // Profile related (Admin doesn't have profile route, redirect to dashboard)
    "profile": 'dashboard', // Fixed: Admin doesn't have /profile route, redirect to dashboard
    "account": 'dashboard', // Fixed: Admin doesn't have /account route, redirect to dashboard

    // Admin specific
    "customer": 'customer',
    "seller": 'seller',
    "contact": 'marketing/contact',
    "newsletter": 'marketing/subscribemail',
    "vendor_management": 'seller', // Fixed: should redirect to /seller, not /vendor
    "product_approval": 'product/allproduct', // Fixed: Admin doesn't have /product/approval route, redirect to products
    "dispute": 'refund', // Fixed: Admin doesn't have /disputes route, redirect to refunds (closest related)
    "compliance": 'dashboard', // Fixed: Admin doesn't have /compliance route, redirect to dashboard
    "promotion": 'marketing/coupons', // Fixed: Admin doesn't have /marketing/promotions route, redirect to coupons
    "discount": 'marketing/coupons', // Fixed: Admin doesn't have /marketing/promotions route, redirect to coupons

    // Cart/Wishlist (not applicable for admin dashboard)
    "wishlist": 'product/allproduct',
    "cart": 'product/allproduct'
    }

    let profileTokenJson = Cookies.get("v&b_token");
    let profileToken = JSON.parse(profileTokenJson);
  let token = profileToken.token;

    const navigate = useNavigate()

  let date = createdAt ? moment(createdAt).fromNow() : '';

  // Get appropriate icon based on category or redirect type
  const getNotificationIcon = () => {
    const iconMap = {
      // Order related
      'order': <ShoppingCartOutlined />,
      'payment': <DollarOutlined />,
      'refund request': <ExclamationCircleOutlined />,
      'withdraw request': <DollarOutlined />,
      'draft': <FileTextOutlined />,

      // Product related
      'product': <FileTextOutlined />,
      'review': <StarOutlined />,

      // Shipping related
      'shipping': <TruckOutlined />,
      'delivery': <TruckOutlined />,
      'tracking': <TruckOutlined />,

      // Profile related
      'profile': <UserOutlined />,
      'account': <UserOutlined />,

      // Admin specific
      'customer': <UserOutlined />,
      'seller': <UserOutlined />,
      'contact': <FileTextOutlined />,
      'newsletter': <FileTextOutlined />,
      'vendor_management': <UserOutlined />,
      'product_approval': <FileTextOutlined />,
      'dispute': <ExclamationCircleOutlined />,
      'compliance': <FileTextOutlined />,
      'promotion': <GiftOutlined />,
      'discount': <GiftOutlined />,

      // Other
      'wishlist': <HeartOutlined />,
      'cart': <ShoppingCartOutlined />
    };

    return iconMap[redirect] || <BellOutlined />;
  };

  // Get priority color using brand colors
  const getPriorityColor = () => {
    switch (priority) {
      case 'urgent': return '#dc3545';
      case 'high': return '#fd7e14';
      case 'medium': return '#ffc107';
      case 'low': return '#28a745';
      default: return 'var(--brand-primary)';
    }
  };

  // Get priority class for styling
  const getPriorityClass = () => {
    switch (priority) {
      case 'urgent': return classes.urgent;
      case 'high': return classes.high;
      case 'medium': return classes.medium;
      case 'low': return classes.low;
      default: return '';
    }
  };


  const handleReq = async () => {
    // Mark as read first if not already seen
    if (!seen && _id) {
      try {
        const register = `${BASE_URL}/notification/${_id}/seen`;
        await axios.put(register, {}, {
            headers: {
              "Content-Type": "application/json",
              'Authorization': `Bearer ${token}`,
            }
        });

        if (refreshFunc) {
          refreshFunc();
        }
      } catch (error) {
        console.error('Error marking notification as seen:', error);
      }
    }

    // Navigate if redirect is provided and link exists
    if (redirect) {
      const redirectPath = links[redirect];
      if (redirectPath) {
        if (parentFunc) parentFunc(false);
        navigate(`/${redirectPath}`);
      } else {
        // If redirect doesn't have a link, just close the modal
        console.warn(`No redirect path found for: ${redirect}`);
        if (parentFunc) parentFunc(false);
      }
    } else {
      // No redirect, just close the modal
      if (parentFunc) parentFunc(false);
    }
  }
   
  return (
    <div
      className={`${classes.notification_item} ${!seen ? classes.unread : classes.read} ${getPriorityClass()}`}
      onClick={handleReq}
      style={{ animationDelay: `${index * 0.05}s` }}
    >
      <div className={classes.notification_content}>
        <div className={classes.icon_container}>
          <div
            className={classes.notification_icon}
            style={{
              backgroundColor: !seen ? getPriorityColor() : '#f0f0f0',
              color: !seen ? '#fff' : '#999'
            }}
          >
            {getNotificationIcon()}
          </div>
          {!seen && <div className={classes.unread_dot} />}
        </div>

        <div className={classes.notification_text}>
          <div className={classes.notification_header}>
            <Text
              strong={!seen}
              className={classes.notification_subject}
              ellipsis={{ tooltip: subject }}
            >
              {subject}
            </Text>
            <div className={classes.priority_badges}>
              {priority === 'urgent' && !seen && (
                <Badge
                  count="URGENT"
                  size="small"
                  style={{ backgroundColor: '#dc3545' }}
                  className={classes.priority_badge}
                />
              )}
              {priority === 'high' && !seen && (
                <Badge
                  count="HIGH"
                  size="small"
                  style={{ backgroundColor: '#fd7e14' }}
                  className={classes.priority_badge}
                />
              )}
            </div>
          </div>

          {description && (
            <Paragraph
              className={classes.notification_description}
              ellipsis={{ rows: 2, tooltip: description }}
            >
              {description}
            </Paragraph>
          )}

          <Text type="secondary" className={classes.notification_time}>
            {date}
          </Text>
        </div>
      </div>
        </div>
    )
}

export default NotificationDiv